module.exports = __webpack_public_path__ + "assets/img/quel-cout-solution-ged.c2e9d84e.jpg";